<template>
<!-- Only load the component when all the data is fetched -->
<div>
  <div>
    <!-- LOADING DIALOG -->
    <utility-loadingDialog
      :loadingDialog="loadingDialog"
      loadingText="Retrieving timesheets.."
    />

  

  </div>
  <div class="bodyCalendar">
    
    <v-card-title class="pa-0 buttonContainer">
      <v-spacer/>
      <v-btn class="mt-3 mb-3 calendarButton text-capitalize" right small color="#0D2B3E" @click="calendarToggle = true">
        <span class="font-weight-black"> Calendar </span>
        <v-icon right small class="pa-0">
          <!-- mdi-plus-box -->
          mdi-chevron-down
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-title v-if="userProfile.IsAdmin" class="pa-2 white black--text">
      <v-avatar size="40" class="mr-3 elevation-5" color="blueBackground">
        <v-icon color="white">
          mdi-account
        </v-icon>
      </v-avatar>
      {{timesheetFor.name}}'s timesheets
    </v-card-title>

    <!-- Calendar starts here -->
    <div class="headerCalendar">
      <!-- Calendar -->
      <widget-calendar
        @monthChanged="monthChanged"
        @dayClicked="dayClicked"
        :timesheetEntries="currentEntriesToDisplay"
      >
      </widget-calendar>
    </div>
    <!-- Scrolling list -->
    <div class="contentCalendar" v-if="dataReceived">
        <div
          v-for="(date,k) in daysInCurrentMonth"
          :key="k"
          class="pa-1"
          :id="'entry-' + date"
        >
          {{datelabel = (singleDate = getDateAndEntries(date), '')}}
          
          <!-- New Entry section start here -->
          <widget-newEntry
            :formData="createEntryTemplate(date)"
            :submitEntryFor="timesheetFor"
            :singleDate="singleDate"
            @updateEntries="refresh"
            :id="'newEntry-' + date"
          />

          <!-- Submitted timesheet entries-->
          <widget-timesheetEntry
            v-for="(entry,j) in singleDate.entries"
            :key="j"
            :entry="entry"
            :submitEntryFor="timesheetFor"
            @updateEntries="refresh"
          />
        </div>
    </div>
  </div>
</div>

</template>

<script>
import moment from 'moment'
import {
  mapState,
  mapMutations
} from 'vuex'

export default {
  props: ['userId'],
  data: () => ({
    calendarToggle: false,
    prevSelectedDate: null,
    scrolled: false,
    loadingDialog: true,
    daysInCurrentMonth: null,
    currentSelectedMonth: null,
    currentSelectedYear: null,
    currentEntriesToDisplay: [],
    dataReceived: false,
    headers: [
      {text: 'Select', value: 'select', sortable: false},
      {text: 'Date', value: 'WorkedOn'},
      {text: 'Activity', value: 'activity.Name'},
      {text: 'Hours', value: 'HoursWorked'},
      {text: 'Notes', value: 'Notes'},
    ]
  }),
  computed: {
    ...mapState('api', ['timesheetData']),
    ...mapState('app', ['userProfile']),
    /**
     * return id of the user, for which the calendar is currently displaying
     * timesheet entries for
     */
    timesheetFor: function() {
      if(!this.userId) {
        // console.log("No user given, get logged in user stuff")
        return {
          id: this.userProfile.id,
          name: `${this.userProfile.GivenName} ${this.userProfile.Surname}`
        }
      } else {
        // console.log("Some other user is given ")
        return this.userId
      }
    },
    
  },
  created() {
    var self = this
    if(this.timesheetData.length == 0) {
      // Grab all the client data if not already done
      this.$timesheetApi.getData().then(pipefishData => {
        // this.loadingDialog = false
        //self.setData(data)
        self.setTimesheetData(pipefishData)
        self.dataReceived = true
      })
    } else {
      self.dataReceived = true
    }
      
  },
  updated() {
    /* If displaying current month then scroll to current day */
    if((this.currentSelectedMonth == (new Date().getMonth() + 1)) && !this.scrolled) {
      this.dayClicked({
        label: new Date().getDate(),
        inMonth: true
      }, true)
      this.scrolled = true
    }
  },
  methods: {
    ...mapMutations('api', ['setTimesheetData']),
    monthChanged(newMonth) {
      this.currentSelectedMonth = newMonth.month
      this.currentSelectedYear = newMonth.year
      this.daysInCurrentMonth = moment(`${this.currentSelectedYear}-${this.currentSelectedMonth}`, 'YYYY-MM').daysInMonth()
      // this.calendarToggle = false
      this.refresh() // Get timesheet entries for the new month
    },
    dayClicked(day, start){
      this.calendarToggle = false
      if(!day.inMonth) {
        return
      }
      var dateContainer = this.$el.querySelector(`#entry-${day.label}`)
      if(dateContainer) {
        dateContainer.scrollIntoView({
          behavior: start ? "auto" : "smooth",
          inline: "start",
          block: "start"
        })
      }

      var newEntryContainer = this.$el.querySelector(`#newEntry-${day.label}`)
      if(newEntryContainer) {
        newEntryContainer.classList.add('selected-border')
      }
      if(this.prevSelectedDate) {
        this.prevSelectedDate.classList.remove('selected-border')
      }
      this.prevSelectedDate = newEntryContainer
      
    },
    /**
     * Given a date, return all activities on that date
     */
    getEntries(date) {
      var result = []
      // TODO: figure out why -1??
      var newDate = moment.utc([this.currentSelectedYear, this.currentSelectedMonth - 1, date])
      
      for(var i in this.currentEntriesToDisplay) {
        var entryMoment = moment(this.currentEntriesToDisplay[i].WorkedOn)
        /* if the dateworked is same as the given date then add entry to list */
        if(entryMoment.isSame(newDate, 'day')) {
          result.push(this.currentEntriesToDisplay[i])
        }
      }
      return result
    },
    createEntryTemplate(date) {
      var dateWorked = moment.utc([this.currentSelectedYear, this.currentSelectedMonth - 1, date])
      return {
        WorkedOn: dateWorked
      }
    },
    /**
     * If user wants to refresh the list and see the new changes to the entries
     */
    refresh() {
      this.loadingDialog = true
      var self = this
      // Month has been changed, so get entries for that month
      const start = moment(`${this.currentSelectedYear}-${this.currentSelectedMonth}`, 'YYYY-MM')
      this.$timesheetApi.getTimesheetEntries(start.toDate(), start.add(1, 'month').toDate(), this.timesheetFor.id).then(entries => {
        self.currentEntriesToDisplay = entries
        self.loadingDialog = false
      })
    },
    myTimesheets() {
      console.log('This functionality is coming soon')
    },
    getDateAndEntries(date) {
      var newDate = moment.utc([this.currentSelectedYear, this.currentSelectedMonth - 1, date]).utcOffset(10)
      var prefix = ""

      if(newDate.isSame(moment(), 'day')) {
        prefix = "Today • "
      } else if (newDate.isSame(moment().add(1, 'd'), 'day')) {
        prefix = "Tomorrow • "
      } else if (newDate.isSame(moment().subtract(1, 'd'), 'day')) {
        prefix = "Yesterday • "
      }
      const dateLabel = prefix + newDate.format("dddd, D MMMM")
      var result = []
      // TODO: figure out why -1??
      //var newDate = moment.utc([this.currentSelectedYear, this.currentSelectedMonth - 1, date])
      var totalHours = 0
      for(var i in this.currentEntriesToDisplay) {
        var entryMoment = moment(this.currentEntriesToDisplay[i].WorkedOn)
        /* if the dateworked is same as the given date then add entry to list */
        if(entryMoment.isSame(newDate, 'day')) {
          result.push(this.currentEntriesToDisplay[i])
          totalHours += this.currentEntriesToDisplay[i].HoursWorked
        }
      }

      // return result
      return {
        isWeekend: newDate.day() === 6 || newDate.day() === 0,
        label: dateLabel,
        entries: result,
        totalHours: totalHours
      }

    },
  }
}
</script>
<style>
.bodyCalendar {
  display: flex;
  flex-direction: column;
  height: 100vh;
  /* background-color: white; */
  /* border: 3px solid red */
  max-width: 1200px;
}
.contentCalendar {
  flex: 1;     /* this is the key; consumes all available height */
  background-color: white;
  overflow: auto;

  /* padding-left: 45px; */
  /* padding-right: 45px */
}
.headerCalendar {
  min-height: 230px;
  height: auto;
  background: white;
  /* border: 3px solid blue */
}

.selected-border {
  border: 1px solid red;
  border-radius: 5px;
}

.calendarButton{
  display: none
}

@media screen and (min-width: 991px) {
  .bodyCalendar{
    padding-top: 20px;
    padding-left:20px;
    padding-right: 20px

  }
}

@media screen  and (max-width: 990px){
  .headerCalendar{
    display: none
  }
  .calendarButton{
    display:initial;
    background-color: #1E618A
  }
  .buttonContainer{
    background-color: #1E618A;
    /* color: white */
  }
}

* {
  margin: 0;
}

</style>
